import React, { useState } from "react";
import { Button } from "@mui/material";
import { Receipt, Edit, Print, Restore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../../auth/PermissionsContext";
import CreateEditInvoiceModal from "./CreateEditInvoiceModal";
import useRestoreInvoice from "../../../../hooks/invoices/useRestoreInvoice";
import PreviewInvoiceModal from "./PreviewInvoiceModal";

const InvoiceActions = ({ program }) => {
    const { i18n } = useTranslation();
    const lang = i18n.language;
    const { has } = usePermissions();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const invoice = program?.invoice;
    const state = invoice?.state || "none";

    const { restoreInvoiceMutate, isPending: isRestoring } = useRestoreInvoice();

    const perms = {
        create: has("invoices_create"),
        edit: has("invoices_edit"),
        print: has("invoices_print"),
        restore: has("invoices_restore"), // Assuming this perm exists, or we use edit
    };

    const handleRestore = () => {
        if (invoice?.id) {
            restoreInvoiceMutate(invoice.id);
        }
    };

    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

    const handlePrint = () => {
        setIsPreviewModalOpen(true);
    };

    return (
        <>
            {state === "none" && perms.create && !program.closed && (
                <Button
                    size="small"
                    variant="contained"
                    startIcon={<Receipt />}
                    onClick={() => setIsModalOpen(true)}
                    color="secondary"
                    sx={{ minWidth: 100 }}
                >
                    {lang === "ar" ? "إنشاء فاتورة" : "Create Invoice"}
                </Button>
            )}

            {(state === "active" || state === "settled") && (
                <>
                    {state === "active" && perms.edit && !program.closed && (
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<Edit />}
                            onClick={() => setIsModalOpen(true)}
                            color="secondary"
                            sx={{ minWidth: 100 }}
                        >
                            {lang === "ar" ? "تعديل الفاتورة" : "Edit Invoice"}
                        </Button>
                    )}
                    {perms.print && (
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<Print />}
                            onClick={handlePrint}
                            color="secondary"
                            sx={{ minWidth: 100 }}
                        >
                            {lang === "ar" ? "معاينة الفاتورة" : "Preview Invoice"}
                        </Button>
                    )}
                </>
            )}

            {state === "archived" && perms.restore && !program.closed && (
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<Restore />}
                    onClick={handleRestore}
                    disabled={isRestoring}
                    color="warning"
                    sx={{ minWidth: 100 }}
                >
                    {isRestoring
                        ? (lang === "ar" ? "جاري الاستعادة..." : "Restoring...")
                        : (lang === "ar" ? "استعادة الفاتورة" : "Restore Invoice")
                    }
                </Button>
            )}

            {isModalOpen && (
                <CreateEditInvoiceModal
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    program={program}
                    existingInvoice={invoice}
                />
            )}

            {isPreviewModalOpen && (
                <PreviewInvoiceModal
                    open={isPreviewModalOpen}
                    onClose={() => setIsPreviewModalOpen(false)}
                    program={program}
                />
            )}
        </>
    );
};

export default InvoiceActions;
